<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <img :src="importedImg2" :alt="altText" class="imgItem2" />
      </div>
    </div>

    <div class="imgBox3 min-w-1400">
      <div class="img3 max-w-1400">
        <img :src="importedImg3" :alt="altText" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4 max-w-1400">
        <img :src="importedImg4" :alt="altText" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5 max-w-1400">
        <img :src="importedImg5" :alt="altText" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6 max-w-1400">
        <img :src="importedImg6" :alt="altText" class="imgItem6" />
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7 max-w-1400">
        <img :src="importedImg7" :alt="altText" class="imgItem7" />
      </div>
    </div>
    <div class="imgBox8 min-w-1400">
      <div class="img8 max-w-1400">
        <img :src="importedImg8" :alt="altText" class="imgItem8" />
      </div>
    </div>
    <div class="imgBox9 min-w-1400">
      <div class="img9 max-w-1400">
        <img :src="importedImg9" :alt="altText" class="imgItem9" />
      </div>
    </div>
    <div class="imgBox10 min-w-1400">
      <div class="img10 max-w-1400">
        <!-- 使用 Flex 布局，水平排列三个大标题 -->
        <div class="titlesContainer">
          <!-- 第一个大标题 -->
          <div class="titleContainer1">
            <h2>เกี่ยวกับเรา</h2>
            <!-- 第一个大标题下的小标题 -->
            <div class="subtitles">
              <ul>
                <router-link to="/" tag="li" class="triangle">
                  <a>พื้นหลัง</a>
                </router-link>
                <router-link to="/questions" tag="li" class="triangle">
                  <a>คำถามที่พบบ่อย</a>
                </router-link>
              </ul>
            </div>
          </div>

          <!-- 第二个大标题 -->
          <div class="titleContainer2">
            <h2>นโยบาย</h2>
            <!-- 第二个大标题下的小标题 -->
            <div class="subtitles">
              <ul class="ul2">
                <li tag="li" class="triangle">
                  <a
                    href="https://mbawt.microfinmobile.com/help/privacy_agreement"
                  >
                    ข้อตกลงความเป็นส่วนตัว
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- 第三个大标题 -->
          <div class="titleContainer3">
            <h2>ติดต่อเรา</h2>
            <!-- 第三个大标题下的小标题 -->
            <div class="subtitles">
              <ul class="ul3">
                <li>Micro Fin Company Limited</li>
                <li class="Li2">
                  ที่อยู่: 863/3 Phet Kasem Road 73000 MUEANG NAKHON PATHOM
                </li>
                <li>โทรศัพท์: 94-823-3850</li>
                <li>อีเมล: service@microfinmobile.com</li>
                <li>เว็บไซต์: https://microfinmobile.com</li>
                <li>
                  <img :src="importedImg11" :alt="altText" class="imgItem11" />
                </li>
                <li class="Li3">แอปจะเปิดตัวเร็วๆ นี้ โปรดคอยติดตาม</li>

                <li>
                  <img :src="importedImg12" :alt="altText" class="imgItem12" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/microfin2/components/img/1_1.png";
import importedImg2 from "@/page/microfin2/components/img/1_2.png";
import importedImg3 from "@/page/microfin2/components/img/1_3.png";
import importedImg4 from "@/page/microfin2/components/img/1_4.png";
import importedImg5 from "@/page/microfin2/components/img/1_5.png";
import importedImg6 from "@/page/microfin2/components/img/1_6.png";
import importedImg7 from "@/page/microfin2/components/img/1_7.png";
import importedImg8 from "@/page/microfin2/components/img/1_8.png";
import importedImg9 from "@/page/microfin2/components/img/1_9.png";
import importedImg10 from "@/page/microfin2/components/img/footer.png";
import importedImg11 from "@/page/microfin2/components/img/button.png";
import importedImg12 from "@/page/microfin2/components/img/111.png";
export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      importedImg7: importedImg7,
      importedImg8: importedImg8,
      importedImg9: importedImg9,
      importedImg10: importedImg10,
      importedImg11: importedImg11,
      importedImg12: importedImg12,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
.imgBox1,
.imgBox10 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}
.imgBox1 {
  margin-top: 80px;
}
.imgBox10 {
  display: flex;
}
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7,
.imgBox8,
.imgBox9 {
  display: flex;
  justify-content: center;
  width: 100%;
}
img {
  display: block;
}

.img1,
.img10 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.img2,
.img3,
.img4,
.img5,
.img6,
.img7,
.img8,
.img9 {
  margin-left: 45px;
  margin-right: 45px;
}
.img10 {
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.left {
  width: 100px;
  height: 100px;
  background-color: aquamarine;
}
.imgItem1,
.imgItem10 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem2 {
  max-width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
}
.imgItem3 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgItem4 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgItem5 {
  max-width: 100%;
  margin-bottom: 100px;
}

.imgItem6 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgItem7 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgItem8 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgItem9 {
  max-width: 100%;
  margin-bottom: 100px;
}
.imgBox10 {
  display: flex;
  justify-content: center;
  background-color: #ca4a3d;
  height: 400px; /* 固定高度 */
  min-width: 1400px;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.titlesContainer {
  display: flex;
  width: 100%;
}

.titleContainer1 {
  width: 200px;
  position: absolute;
  margin-top: 30px;
  margin-left: 200px;
}
.titleContainer2 {
  padding-left: 450px;
  margin-top: 30px;
  width: 400px;
}
.titleContainer3 {
  margin-left: 320px;
  margin-top: 30px;
}
.subtitles {
  display: flex;
  flex-direction: column;
}

li {
  color: #ffffff;
  margin-top: 10px;
}
h2 {
  color: #ffffff;
}
.Li2 {
  width: 900px;
}
.ul2 li {
  width: 220px;
}
.subtitles ul li.triangle::before {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 8px; /* 调整这里以改变三角形的大小 */
  border-color: transparent transparent transparent #ffffff; /* 设置三角形的颜色 */
  margin-right: 20px; /* 图标与文字之间的间距 */
}

.triangle a {
  color: #ffffff;
  text-decoration: none; /* 添加这一行，去掉下划线 */
  cursor: pointer; /* 添加这一行，显示手型光标 */
}
.a2 {
  width: 400px;
}
li {
  font-size: 18px;
}
.Li3 {
  color: #c1c0c0;
  font-size: 14px;
}
</style>
